import { Mail, ArrowUpRight } from "lucide-react";
import { CONTACT, IMAGES } from "./data";
import { Reveal, SectionHead } from "./shared";

export default function Contact() {
  return (
    <section id="contact" data-testid="contact-section" className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img src={IMAGES.technician} alt="" aria-hidden="true" className="h-full w-full object-cover opacity-15" loading="lazy" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0A0E17] via-[#0A0E17]/85 to-[#0A0E17]" />
      </div>

      <div className="relative mx-auto max-w-7xl px-5 py-24 lg:px-8 lg:py-32">
        <SectionHead
          index="07"
          overline="Contact"
          title="Talk to the founder directly"
          note="No IR firm, no gatekeeping. One inbox, one phone line, one person accountable for every number on this page."
        />

        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:items-end">
          <Reveal className="lg:col-span-7">
            <p className="font-display text-3xl font-semibold uppercase tracking-tight text-slate-100 sm:text-4xl">
              {CONTACT.name}
            </p>
            <p className="mt-1 font-mono text-xs uppercase tracking-[0.25em] text-[#FF5500]">
              {CONTACT.role} · WorkSafeAgent LLC · Abilene, TX
            </p>
            <div className="mt-8 flex flex-wrap gap-4">
              <a
                data-testid="contact-email-cta"
                href={`mailto:${CONTACT.email}?subject=$250K%20Bridge%20—%20Investor%20Inquiry`}
                className="flex items-center gap-2 rounded-full bg-[#FF5500] px-6 py-3 font-mono text-sm font-semibold uppercase tracking-widest text-white transition-colors duration-200 hover:bg-[#E04B00]"
              >
                <Mail className="h-4 w-4" />
                {CONTACT.email}
              </a>
            </div>
          </Reveal>

          <Reveal delay={0.12} className="lg:col-span-5">
            <div className="clip-frame border border-slate-800 bg-[#0D1320]/90 p-7">
              <p className="font-mono text-xs uppercase tracking-[0.25em] text-slate-400">Elsewhere</p>
              <div className="mt-4 space-y-3">
                <a
                  data-testid="contact-link-wsafe"
                  href={CONTACT.site}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-between border-b border-slate-800 pb-3 text-sm text-slate-300 transition-colors hover:text-[#FF5500]"
                >
                  wsafe.ai — research & writing
                  <ArrowUpRight className="h-4 w-4" />
                </a>
                <a
                  data-testid="contact-link-worksafeagent"
                  href={CONTACT.product}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-between text-sm text-slate-300 transition-colors hover:text-[#FF5500]"
                >
                  worksafeagent.com — the product
                  <ArrowUpRight className="h-4 w-4" />
                </a>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
